import * as Sentry from '@sentry/react';
import { User } from '../types';
import { ScopeContext } from '@sentry/types/types/scope';
import { getAllExperiments } from '@upheal/utils/App.constants';

export const TAG_EMPTY_VALUE = 'null';

export class SentryAutogroupError extends Error {
    constructor(message: string) {
        super(message);
    }
}

export const startSentryReplay = (reason?: string) => {
    // We need to trick Sentry to think that error has occurred, so that it will start recording the session replay
    // eslint-disable-next-line no-restricted-syntax
    Sentry.captureException(
        new Error('startSentryReplay'),
        reason
            ? {
                  tags: {
                      reason,
                  },
              }
            : undefined,
    );
};

export const sentryUnmaskText = { 'data-sentry-unmask': true };

export const setSentryUser = (user: User) => {
    Sentry.setUser({
        id: user.id,
    });
    Sentry.setTag('user_role', user.role);
    Sentry.setTag('upheal_user', user.email?.includes('@upheal.io'));
    Sentry.setTag(
        'build_target',
        import.meta.env.VITE_SENTRY_WEBAPP_BUILD_TARGET,
    );
};

export const captureException = (
    error: unknown,
    extra?: ScopeContext['extra'] & {
        // prevent passing data belonging to 3rd argument
        [k in keyof ScopeContext]?: never;
    },
    context?: Partial<ScopeContext> & {
        disableAutogrouping?: boolean;
    },
) => {
    const { disableAutogrouping, ...sentryContext } = context ?? {};

    // eslint-disable-next-line no-restricted-syntax
    return Sentry.captureException(
        typeof error === 'string'
            ? disableAutogrouping
                ? new Error(error)
                : new SentryAutogroupError(error)
            : error,
        {
            extra: {
                ...extra,
                experiments: getAllExperiments(),
            },
            ...sentryContext,
        },
    );
};
